import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';

import { translate } from '@portal/services/i18n';
import AccountPayable from './AccountPayable/AccountPayable';
import FileDetails from './FileDetails/FileDetails';
import GeneratePaymentByFile from './GeneratePaymentByFile/GeneratePaymentByFile';
import AccountReceivable from './AccountReceivable/AccountReceivable';
import { hasAccess } from '@portal/utils/hasAccess';
import RolesType from '@portal/enum/rolesType';

import useReduxState from '@portal/hooks/useReduxState';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';

const PaymentNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.PAYMENT,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const {
    user: { roles },
  } = useReduxState();

  return (
    <Switch>
      {hasAccess(roles, RolesType.PAYABLE_READ) && (
        <Route exact path={getRouteStackPath('PAYABLE', 'ACCOUNT_PAYABLE')}>
          <PanelContent
            pageTitle={translate('PAGES.PAYMENT.ACCOUNT_PAYABLE.TITLE')}
            pageDescription={translate(
              'PAGES.PAYMENT.ACCOUNT_PAYABLE.DESCRIPTION'
            )}
          >
            <AccountPayable />
          </PanelContent>
        </Route>
      )}

      {hasAccess(roles, RolesType.RECEIVABLE_READ) && (
        <Route
          exact
          path={getRouteStackPath('RECEIVABLE', 'ACCOUNT_RECEIVABLE')}
        >
          <PanelContent
            pageTitle={translate('PAGES.PAYMENT.ACCOUNT_RECEIVABLE.TITLE')}
            pageDescription={translate(
              'PAGES.PAYMENT.ACCOUNT_RECEIVABLE.DESCRIPTION'
            )}
          >
            <AccountReceivable />
          </PanelContent>
        </Route>
      )}

      <Route exact path={getRouteStackPath('FILES_HANDLER', 'FILE_DETAILS')}>
        <PanelContent
          pageTitle={translate('PAGES.PAYMENT.FILE_DETAILS.TITLE')}
          pageDescription={translate('PAGES.PAYMENT.FILE_DETAILS.DESCRIPTION')}
        >
          <FileDetails />
        </PanelContent>
      </Route>

      {hasAccess(roles, RolesType.PAYABLE_CREATE) && (
        <Route
          exact
          path={getRouteStackPath('FILES_HANDLER', 'GENERATE_BY_FILE')}
        >
          <PanelContent
            pageTitle={translate('PAGES.PAYMENT.GENERATE_BY_FILE.TITLE')}
            pageDescription={translate(
              'PAGES.PAYMENT.GENERATE_BY_FILE.DESCRIPTION'
            )}
          >
            <GeneratePaymentByFile />
          </PanelContent>
        </Route>
      )}
    </Switch>
  );
};

export default PaymentNavigationStack;
